(function () {
  'use strict';

  var ENGRAVING_HANDLE = 'bottle-engraving';
  var engravingProduct = null;

  fetch('/products/' + ENGRAVING_HANDLE + '.js')
    .then(function (r) {
      if (!r.ok) throw new Error('Not found');
      return r.json();
    })
    .then(function (p) {
      engravingProduct = {
        variantId: p.variants[0].id,
        price: p.variants[0].price,
      };
      var priceFormatted = '$' + (engravingProduct.price / 100).toFixed(2);
      document.querySelectorAll('.pdp-engraving .engraving__price').forEach(function (el) {
        el.textContent = priceFormatted;
      });
      document.querySelectorAll('.pdp-engraving').forEach(function (el) {
        el.hidden = false;
      });
    })
    .catch(function () {
      document.querySelectorAll('.pdp-engraving').forEach(function (el) {
        el.hidden = true;
      });
    });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp-engraving').forEach(function (wrap) {
      var textInputs = wrap.querySelectorAll('.engraving__text');
      var propInputs = wrap.querySelectorAll('.engraving__prop');

      if (!textInputs.length || !propInputs.length) return;

      textInputs.forEach(function (textInput) {
        var lineNum = textInput.dataset.lineNum;
        var propInput = wrap.querySelector('input[name="properties[Engraving Line ' + lineNum + ']"]');
        var counter = textInput.parentElement.querySelector('.engraving__count');

        if (!propInput) return;

        textInput.addEventListener('input', function () {
          var val = textInput.value;
          propInput.value = val;
          if (counter) counter.textContent = val.length;
          propInput.disabled = val.trim() === '';
        });
      });
    });
  });
})();
